import React from "react";
import { GoogleLogin } from "@react-oauth/google";

interface LoginViewProps {
  username: string;
  password: string;
  busy: boolean;
  error: string | null;
  firstInputRef: React.RefObject<HTMLInputElement | null>;
  onUsernameChange: (v: string) => void;
  onPasswordChange: (v: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onGoogleSuccess: (credential: string) => void;
  onApple: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onBack: () => void;
  onClose: () => void;
}

export default function LoginView({
  username,
  password,
  busy,
  error,
  firstInputRef,
  onUsernameChange,
  onPasswordChange,
  onSubmit,
  onGoogleSuccess,
  onApple,
  onBack,
  onClose,
}: LoginViewProps) {
  return (
    <div className="login-card">
      <button
        className="login-back"
        type="button"
        onClick={onBack}
        disabled={busy}
      >
        ← Terug
      </button>
      <button
        className="login-close"
        type="button"
        onClick={onClose}
        aria-label="Sluiten"
      >
        ×
      </button>

      <h3 className="login-title">Inloggen</h3>
      <div className="login-divider" />

      <form className="login-form" onSubmit={onSubmit}>
        <div className="login-field">
          <label className="login-label">E-mail</label>
          <input
            ref={firstInputRef}
            type="email"
            value={username}
            onChange={(e) => onUsernameChange(e.target.value)}
            required
            autoComplete="email"
          />
        </div>

        <div className="login-field">
          <label className="login-label">Wachtwoord</label>
          <input
            type="password"
            value={password}
            onChange={(e) => onPasswordChange(e.target.value)}
            required
            autoComplete="current-password"
          />
        </div>

        {error && (
          <div style={{ color: "#ffd1d1", fontWeight: 700 }}>{error}</div>
        )}

        <div className="login-actions">
          <button className="login-submit" type="submit" disabled={busy}>
            {busy ? "Even..." : "Inloggen"}
          </button>
        </div>
      </form>

      <div className="login-links" style={{ display: "flex", flexDirection: "column", gap: "10px", alignItems: "center" }}>
        <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <GoogleLogin
            onSuccess={(response) => {
              if (response.credential) {
                onGoogleSuccess(response.credential);
              }
            }}
            onError={() => {
              console.error("Google Login Failed");
            }}
            useOneTap={false}
            shape="rectangular"
            theme="outline"
            text="signin_with"
            size="large"
            width="100%"
          />
        </div>
      </div>
    </div>
  );
}
